export default "__VITE_ASSET__f0a439d1__"